import React, { Component } from "react";
import { Col, Row, Button, Label } from "reactstrap";
import { observer, inject } from "mobx-react";
import { Container } from "reactstrap";
import { toast } from "react-toastify";
import DataWrapper from "../../principal/containers/DataWrapper";
import AgendVgmStore from "../stores/AgendVgmStore";
import FiltrosAgendVgm from "../componentes/FiltrosAgendVgm";
import TabelaAgendVgm from "../componentes/TabelaAgendVgm";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import ModalForm from "../../comum/components/ModalForm";
import FormInputCNPJCPF from "../../comum/components/FormInputCNPJCPF";
import FormInput from "../../comum/components/FormInput";
import ModalAviso from "../../comum/components/ModalAviso";
import AddAgendVgm from "../componentes/AddAgendVgm";

@inject("store")
@DataWrapper
@observer
export default class AgendVgm extends Component {
  constructor(props) {
    super(props);
    this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    this.loginStore = this.props.store.loginStore;
    this.store = new AgendVgmStore();

    this.state = {
      openModal: false
    };
  }
  
  can = (operacao = "C", tarefa = "AgendamentoVgm") => this.loginStore.can(tarefa, operacao)

  componentDidMount() {
    this.tituloPaginaStore.setTitulo("VGM");
  }

  toggleModal = async () => {
    this.setState({ openModal: !this.state.openModal });
  };

  render() {
    const qtdeDados = this.store.dados ? this.store.dados.length : 0;
    return (
      <React.Fragment>
        {this.can("I") && this.state.openModal && (
          <AddAgendVgm
            toggleModal={this.toggleModal}
            salvar={model => this.store.salvarSolicitacaoVgm(model)}
          />
        )}
        <Container className="tela-botoes-inclusao-topo" fluid>
          <Row className="botoes-inclusao-topo">
            {this.can("I") &&
              <Col>
                <Button
                  className="btn-com-bordas-primary"
                  onClick={this.toggleModal}
                >
                  Nova Solicitação
              </Button>
              </Col>
            }
          </Row>
          <FiltrosAgendVgm
            filtros={this.store.filtros}
            onChangeFiltro={(campo, valor) => {
              this.store.onChangeFiltro(campo, valor);
            }}
            handleFiltrar={() => this.store.listar()}
          />
          <TabelaAgendVgm
            dados={this.store.dados}
            colunas={this.store.colunas}
            loading={this.store.loading}
            defaultSorted={this.store.defaultSorted}
            filtrado={this.store.filtrado}
          />
        </Container>
        <Footer>
          <FooterContent>
            {qtdeDados > 0 && (
              <div className="justify-content-between">
                <div>
                  <b>{qtdeDados}</b> registro{qtdeDados > 1 ? "s" : ""}
                </div>
              </div>
            )}
          </FooterContent>
        </Footer>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agend-vgm/telas/AgendVgm.js